import React, { Component } from 'react'
import {GoogleMap, withScriptjs, withGoogleMap} from 'react-google-maps';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';



function Map(){
    return(
        <GoogleMap defaultZoom={20} defaultCenter={{lat:37.463890, lng: -122.429523}}/>
    );
}
const WrappedMap = withScriptjs(withGoogleMap(Map));

export default class Contact extends Component {
    render() {
        return (
            <React.Fragment>
           <div style={{background:'white', margin:'auto'}}>     
           <div className="contact-info" style={{margin:'auto'}}>
           <Container>
                <Row>
                    <Col md={6}>
                    <h1><i className="fas fa-phone-alt" style={{fontSize:'44px', color:'#009ffd'}}/> Call Us </h1> 
                     <h2><a href="tel:1-650-726-4071">1-650-726-4071</a></h2>
                     </Col>
                     <Col md={6}>
                     <h1><i className="fa fa-envelope" style={{fontSize:'50px', color:'#009ffd', margin:'auto'}}/> Email Us </h1> 
                     <h2><a href="mailto:cunhagrocer@gmail.com?Subject=Inquiry">Inquiry Here</a></h2>
                     </Col> 
                </Row>
           </Container>
           </div>     
            <div className="contact-div">
                <h2><i className="fas fa-map-pin" style={{color:'red'}} /> Find Us</h2>
            <div style={{width:'70vw', height:'70vh', margin:'auto'}}>
            <WrappedMap googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyDXlgYNOpYH4aV_HdXuSRdkWbmiK8pxJ1U`} 
            loadingElement = {<div style={{height:'100%'}} />}
            containerElement = {<div style={{height:'100%'}} />}
            mapElement = {<div style={{height:'100%'}} />}
            
            />
            <p>Our store is located conveniently on the corner of Kelly Ave, and Main Street. Enjoy your meal
                across the street in Mac Dutra park with seating and public restrooms.
            </p>
            </div>
          </div>
          </div>
          </React.Fragment>
        
        )
    }
}
